import { useRef, useEffect } from "react";
import "./About.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import {
  FaTags,
  FaChessKing,
  FaUserCog
} from "react-icons/fa";

gsap.registerPlugin(ScrollTrigger);
gsap.ticker.lagSmoothing(1000, 16);

export default function About() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const featuresRef = useRef([]);

  const titleColors = ["#f36b08", "#fff", "#08469a"];

  useEffect(() => {
    const ctx = gsap.context(() => {

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          once: true,
        },
      });

      tl.from(titleRef.current, {
        y: 80,
        opacity: 0,
        duration: 1.2,
        ease: "power4.out",
      })

      .from(
        textRef.current.children,
        {
          y: 30,
          opacity: 0,
          stagger: 0.12,
          duration: 0.8,
          ease: "power3.out",
        },
        "-=0.8"
      )

      .from(
        featuresRef.current,
        {
          y: 0,
          opacity: 0,
          stagger: 0.15,
          duration: 1,
          ease: "power4.out",
        },
        "-=0.5"
      );

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const features = [
    {
      icon: <FaTags />,
      title: "Scalable AI & IoT Integration",
      desc: "Future-ready systems with edge intelligence and cloud AI.",
    },
    {
      icon: <FaChessKing />,
      title: "Cognitive Device Solutions",
      desc: "Smart automation with predictive intelligence at the edge.",
    },
    {
      icon: <FaUserCog />,
      title: "Robust Data Ecosystems",
      desc: "Secure pipelines with real-time analytics and insights.",
    },
  ];

  return (
    <section
      id="about"
      className="about-xable"
      ref={sectionRef}
    >
      <div className="container">
        <div className="row g-0 align-items-stretch">

          {/* LEFT */}
          <div className="col-lg-6">
            <div className="about-left">

              <span className="about-badge">
                ABOUT COMPANY
              </span>

              <h2 ref={titleRef}>
                Let's turn your vision into a{" "}
                <span>masterpiece.</span>
              </h2>

              <div ref={textRef}>
                <p>
                  Glintgan Technologies build intelligent digital ecosystems
                  powered by AI, IoT, and automation for
                  next-generation businesses.
                </p>

                <p>
                  Our mission is to transform complex
                  systems into seamless, scalable and
                  predictive platforms.
                </p>
              </div>

              <div className="about-line"></div>

            </div>
          </div>

          {/* RIGHT */}
          <div className="col-lg-6">
            <div className="about-right">

              {features.map((item, index) => (
                <div
                  key={index}
                  className="feature"
                  ref={(el) => (featuresRef.current[index] = el)}
                >
                  <div className="icon">
                    {item.icon}
                  </div>

                  <div className="feature-content">
                    <h4 style={{ color: titleColors[index] || "#000" }}>
                      {item.title}
                    </h4>

                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}